// import EllipsisSvg from "../../icons/Ellipsis";
// import Button from "../baseComponents/Button/Button";
// import ButtonWitchMenu from './ButtonWitchMenu';

import {useSelector} from "react-redux";
import {Link} from "react-router-dom";

import {Checkbox, IconButton, Tooltip} from "@mui/material";

import LayersIcon from "@mui/icons-material/Layers";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import DrawIcon from "@mui/icons-material/Draw";

// import RouteIcon from '@mui/icons-material/Route';
import GeoIconArray from "../GeoIconArray";
import useStyles from "./useStyles";
import ColorInformer from "../ColorInformer";
import mapStateToProps from "./mapStateToProps";
import {memo} from "react";

function GeozoneInfoObj(props) {
  const {
    /**полный объект данных об геозоне */
    dataObj,
    /**Ф-ция для сохранения объекта */
    updateDataObj = () => {},
    /**ф-ция для перехода к редактированию объекта на карте */
    editGeometry = () => {},
  } = props;
  const { id, name, active, color, icon, polygon } = dataObj;

  /*
    color
    company
    icon
    id
    name
    polygon
    project
    */
  const { rights = [] } = useSelector(mapStateToProps);
  const canEdit = !!rights?.["dirGeozones-edit"];

  const classes = useStyles();

  const handleCheckBoxClick = () => {
    updateDataObj({ active: !active });
  };

  return (
    <div className={classes.info}>
      <div className={classes.infoWrap}>
        <Checkbox
          className={classes.checkbox}
          onClick={handleCheckBoxClick}
          checked={active}
        />
        <span className={classes.icon}>
          <GeoIconArray iconNum={icon} fontSize="small" />
        </span>
        <span className={classes.icon}>
          <ColorInformer color={color} />
        </span>
        {polygon?.length ? (
          <Tooltip title="Есть сопоставленная область на карте">
            <LayersIcon fontSize="small" />
          </Tooltip>
        ) : (
          <Tooltip title="Отсутствует сопоставленная область на карте">
            <LayersClearIcon fontSize="small" />
          </Tooltip>
        )}
        <div className={classes.title}>
          <Tooltip title={name}><span>{name}</span></Tooltip>
        </div>
        {canEdit ? (
          <Tooltip
            title={
              polygon?.length
                ? "Заменить существующую геометрию"
                : "Создать новую геометрию"
            }
          >
            <IconButton
              style={{ padding: "0" }}
              LinkComponent={Link}
              to={`/geozone/${id}`}
            >
              <DrawIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      {/* <ButtonWitchMenu id={key_item} name={title}/> */}
    </div>
  );
}

export default memo(GeozoneInfoObj);
